<template>
  <div class="user-list">
    <el-tabs v-model="searchParam.status" type="card" @tab-click="getList">
      <el-tab-pane label="上架" name="2"></el-tab-pane>
      <el-tab-pane label="下架" name="1"></el-tab-pane>
    </el-tabs>
    <div class="search-bar flex">
      <div class="left">
        <el-select v-model="searchParam.teach_uuid" placeholder="授课老师" clearable @clear="getList">
          <el-option v-for="item in teacherList" :key="item.uuid" :label="item.name" :value="item.uuid"> </el-option>
        </el-select>
        <el-input v-model="searchParam.keyword_search" placeholder="输入标题" clearable @clear="getList"></el-input>
        <el-date-picker
          v-model="dates"
          type="daterange"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="changeDate"
        >
        </el-date-picker>
        <el-button type="primary" @click="getList('clear')">查询</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </div>
      <div class="right">
        <el-button type="primary" @click="toDetail()">新增直播课程</el-button>
      </div>
    </div>
    <div class="table">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="live_id" label="id" fixed="left" width="120px"> </el-table-column>
        <el-table-column prop="title" label="课程名称" width="120px"> </el-table-column>
        <el-table-column prop="img" label="封面" width="120px">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.cover"
              fit="contain"
              :preview-src-list="[scope.row.cover]"
            >
            </el-image> </template
        ></el-table-column>
        <el-table-column prop="teacher_name" label="授课老师" width="120px"> </el-table-column>
        <el-table-column prop="start_time" label="开播时间" width="160"></el-table-column>
        <el-table-column prop="price" label="现价"> </el-table-column>
        <el-table-column prop="original_price" label="原价"> </el-table-column>
        <el-table-column prop="sales" label="销量"> </el-table-column>

        <el-table-column prop="create_time" label="创建时间" width="160"> </el-table-column>
        <el-table-column label="操作" fixed="right" width="280">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="toDetail(scope.row)">查看详情</el-button>
            <el-button class="mid-blue" @click="setTop(scope.row)">{{
              scope.row.is_top == 1 ? "置顶" : "取消置顶"
            }}</el-button>
            <el-button class="mid-blue" @click="xiajia(scope.row)">{{
              scope.row.status == 2 ? "下架" : "上架"
            }}</el-button>
            <el-button class="mid-red" @click="deleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getLiveList, deleteLive, setTopLive, LiveStatus } from "@/api/live.js";
import { getTeacherList } from "@/api/teacher.js";
import { mixin } from "@/mixins/pagination.js";
export default {
  mixins: [mixin],
  data() {
    return {
      loading: false,
      teacherList: [],
      dates: [],
      searchParam: {
        keyword_search: "",
        status: "2",
        start_time: "",
        end_time: "",
      },
      tableData: [],
    };
  },
  mounted() {
    this.getList();
    this.getTeacher("");
  },
  methods: {
    changeDate(val) {
      if (Array.isArray(val)) {
        this.searchParam = {
          ...this.searchParam,
          start_time: val[0],
          end_time: val[1],
        };
      } else {
        this.searchParam = {
          ...this.searchParam,
          start_time: "",
          end_time: "",
        };
        this.getList();
      }
      console.log(val);
    },
    resetSearch() {
      this.searchParam = { status: "2" };
      this.dates = [];
      this.getList();
    },
    getTeacher(keyword_search) {
      getTeacherList({ type: 1 }).then((res) => {
        if (res.data instanceof Array) {
          this.teacherList = res.data;
        }
      });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/add-live",
        query: row,
      });
    },

    setTop(row) {
      setTopLive(row.uuid).then((res) => {
        if (res) {
          this.$message.success("成功");
          this.getList();
        }
      });
    },
    xiajia(row) {
      LiveStatus(row.uuid).then((res) => {
        if (res) {
          this.$message.success("成功");
          this.getList();
        }
      });
    },
    deleteItem(row) {
      this.$confirm("确定要删除该直播吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteLive(row.uuid).then((res) => {
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getList() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
      };
      this.loading = true;
      const res = await getLiveList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
